import { showToastNotification } from '../../store/ui/toasts/toastsActions';
import { ToastType } from '../../store/ui/toasts/toastsTypes';
import { Dispatch } from 'redux';

export type TDMMessageType = 'success' | 'error' | 'warning' | 'info';

const convertMsgType = (type: TDMMessageType) => {
  const conversionMap = {
    success: ToastType.Success,
    error: ToastType.Danger,
    warning: ToastType.Warning,
    info: ToastType.Info,
  };
  return conversionMap[type];
};

export const showTDMMessage = (type: TDMMessageType, message: string, dispatch: Dispatch<any>, delay?: number) => {
  const msg = message.endsWith('.') ? message.slice(0, -1) : message;
  dispatch(showToastNotification(convertMsgType(type), msg, '', delay));
};
